import { uid } from '../../../../lib/uid';

/*
  Wordings a screening question plausibly takes, which is what this form actually configures.
  Plausible vocabulary is the right call here: unlike a person's name, a question's wording never
  leaves `rsys_` and never lands in the identity store, and an unreadable one would make the
  generated form worse at the one job it has — showing what the fields are for.
*/
const QUESTIONS = [
  'Have you ever been the subject of a fact-finding investigation by this agency?',
  'Do you hold a concurrent position in any other government office?',
  'Have you undergone a pre-employment medical examination in the last twelve months?',
  'Are you a beneficiary of any scholarship carrying a return-service obligation?',
  'Do you have a pending application for any other position in this agency?',
];

/**
 * A sample survey question, so the create form fills in one click.
 *
 * The item number is suffixed because it is unique among active rows — Autogenerate is most
 * useful clicked repeatedly, and without a suffix the second click would be refused as a
 * duplicate. **The modal applies it on a create only**: on an edit the number is the one field
 * the reader did not choose, and "never a field the reader has already decided" forbids it.
 *
 * **The flags stay at their least surprising values.** `collectsDetails` is on, because a yes/no
 * question with nowhere to explain the yes is the unusual one; the other four are off. A
 * generator that randomised them would draw a different form on every click, and a generator the
 * reader cannot predict is worse than one that fills less.
 */
export function sampleSurveyQuestion(): {
  number: string;
  text: string;
  guidance: string;
  description: string;
  collectsDetails: boolean;
  collectsDate: boolean;
  collectsCaseStatus: boolean;
  collectsIdNumber: boolean;
  collectsCountry: boolean;
} {
  const tag = uid().slice(0, 4).toUpperCase();

  return {
    number: `S-${tag}`,
    text: QUESTIONS[Math.floor(Math.random() * QUESTIONS.length)],
    guidance: 'Answer for the whole of your service, not only this agency.',
    description: `Sample question ${tag}. Delete it once the real questionnaire is in.`,
    collectsDetails: true,
    collectsDate: false,
    collectsCaseStatus: false,
    collectsIdNumber: false,
    collectsCountry: false,
  };
}
